import { TabBar as ITabBar, TabBarProps } from '../../../models/tab-bar'
import Tab from './Tab/Tab'
import './TabBar.scss'

const TabBar = (props: TabBarProps) => {
    const { tabs, activeTab } = props
    const tabBarClass = 'tab-bar'
    return (
        <div className={tabBarClass}>
            {tabs.map((tab: ITabBar) => (
                <Tab
                    key={tab.id}
                    name={tab.keyName}
                    active={tab.id === activeTab}
                    onClick={props.onClick.bind(null, tab.id)}
                />
            ))}
        </div>
    )
}

export default TabBar
